"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 * Retorna los umacreditos que haya en Firestore
 *
 */
function useUmacreditos(firestore, uid) {
    const userRef = (0, firestore_2.doc)(firestore, `user/${uid}`);
    return (0, firestore_1.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.User({ name: "umacredits",
        path: `user/${uid}`
    }, [uid]), userRef, {}, { select: (data) => {
            if (data?.uma_creditos) {
                return data.uma_creditos;
            }
            return 0;
        } });
}
exports.default = useUmacreditos;
